import React, { PropsWithChildren, useState } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me } from 'service/user'
import { CircularCheckbox } from 'components/CircularCheckbox'

import { IncludeAddTooltip } from '../IncludeAddTooltip'
import useTranslation from '../../../../../hooks/useTranslation'

interface IncludeAddDisplayProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  userInfo: Me
}
export const IncludeAddDisplay = ({
  watch,
  setValue,
  control,
  userInfo,
}: PropsWithChildren<IncludeAddDisplayProps>) => {
  const { t } = useTranslation()
  const [tooltipStatus, setTooltipStatus] = useState<boolean>(false)
  return (
    <div className="price  my-[40px]">
      <div className="flex flex-col  md:mb-[16px] gap-4  ">
        <p className="flex items-center font-bold text-[18px]">
          {t('productVideoEditor.includeAddTooltip.title')}
          <span
            className="text-[white] text-[14px] bg-[#8C9DC2] px-3 py-1 rounded-[4px] ml-2 cursor-pointer"
            onClick={() => {
              setTooltipStatus((prev) => !prev)
            }}
          >
            {t('productVideoEditor.includeAddTooltip.example')}
          </span>
        </p>
        {tooltipStatus && (
          <IncludeAddTooltip setTooltipStatus={setTooltipStatus} />
        )}
        <div className="grid grid-cols-2 cursor-pointer">
          {[
            { name: t('productVideoEditor.testEffect.include'), value: true },
            { name: t('productVideoEditor.testEffect.exclude'), value: false },
          ].map((el, index) => {
            return (
              <div key={index}>
                <label
                  onClick={() => {
                    setValue('includeAdd', el.value)
                  }}
                >
                  <Controller
                    render={({ field }) => (
                      <CircularCheckbox
                        {...field}
                        id={index}
                        checked={watch('includeAdd') === el.value}
                        label={el.name}
                        onChange={() => {
                          setValue('includeAdd', el.value)
                        }}
                        disabled={
                          !userInfo || userInfo?.userType === 'normalUser'
                        }
                      />
                    )}
                    name="includeAdd"
                    control={control}
                  />
                </label>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
